<template>
  <Pull :onPull="pull" ref="pull">
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>房屋列表</span>
    </div>
    <!-- 搜索功能部分 -->
    <div class="search-content">
      <a-input
        placeholder="房间门牌"
        v-model="listParam.roomIdOrNo"
        :allowClear="true"
        style="width:86%;"
      >
        <a-icon slot="prefix" type="search" />
      </a-input>
      <span class="searchBtn" @click="inputSearch">搜索</span>
    </div>
    <!-- 状态筛选部分 -->
    <div class="status-select">
      <div @click="areaShow = true">
        <span>区域</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="typeShow = true">
        <span>类型</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="statusShow = true">
        <span>状态</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="rankShow = true">
        <span>排序</span>
        <a-icon type="down" />
      </div>
    </div>
    <!-- 列表部分 -->
    <div class="list-content" v-if="resdata.length > 0">
        <div
          class="content-part"
          @click="navigatePage(item)"
          v-for="(item, index) in resdata"
          :key="index"
        >
          <img :src="item.roomIcon" mode="" />
          <div>
            <div>
              <span>{{ item.buildName }}-{{ item.roomNo }}</span>
              <!-- <span>未抄表</span> -->
            </div>
            <span
              >{{ item.roomArea }}m²/{{ item.rentAreaName }}/{{
                item.buildName
              }}/{{ item.floorName }}</span
            >
            <div>
              <span>¥{{ item.recommendPrice * item.roomArea }} /月</span>
              <span>{{ item.recommendPrice }}元/平</span>
            </div>
          </div>
        </div>
    </div>
    <div class="no-data" v-else>
      <img src="../assets/propertyImg/no-data.png" alt="" />
      <span>暂无房屋数据列表</span>
    </div>
    <!-- <div class="loadMore" v-if="isData" @click="gainMore">
      加载更多
    </div> -->
    <!-- <div class="noMore" v-if="!isData">
      没有更多了。。。
    </div> -->
    <!-- 区域选择 -->
    <van-action-sheet v-model="areaShow">
      <van-picker
        title="区域"
        show-toolbar
        value-key="name"
        :columns="areaActions"
        @confirm="areaSelect"
        @cancel="areaShow = false"
      />
    </van-action-sheet>
    <!-- 类型选择 -->
    <van-action-sheet v-model="typeShow">
      <van-picker
        title="类型"
        show-toolbar
        value-key="name"
        :columns="typeActions"
        @confirm="typeSelect"
        @cancel="typeShow = false"
      />
    </van-action-sheet>
    <!-- 状态选择 -->
    <van-action-sheet v-model="statusShow">
      <van-picker
        title="状态"
        show-toolbar
        value-key="name"
        :columns="statusActions"
        @confirm="statusSelect"
        @cancel="statusShow = false"
      />
    </van-action-sheet>
    <!-- 排序选择 -->
    <van-action-sheet v-model="rankShow">
      <van-picker
        title="排序"
        show-toolbar
        value-key="name"
        :columns="rankActions"
        @confirm="rankSelect"
        @cancel="rankShow = false"
      />
    </van-action-sheet>
  </div>
  </Pull>
</template>
<script>
import { areaList, roomList } from "../axios/property";
import Pull from '../commonComponents/PullRefresh'
export default {
  components: {
    Pull
  },
  data() {
    return {
      resdata: [],
      areaShow: false, // 区域选择框
      areaActions: [], // 区域集合
      typeShow: false, // 类型选择框
      typeActions: [
        // 类型种类
        { name: "全部", value: null },
        { name: "住宅", value: 1 },
        { name: "办公室", value: 2 },
        { name: "厂房", value: 3 },
        { name: "店铺", value: 4 },
        { name: "仓库", value: 5 },
        { name: "出租", value: 6 },
      ],
      statusShow: false, // 状态选择框
      statusActions: [
        // 状态种类
        { name: "全部", value: null },
        { name: "已出租", value: 2 },
        { name: "占用", value: 3 },
        { name: "预定", value: 1 },
        { name: "空置", value: 4 },
      ],
      rankShow: false, // 排序选择框
      rankActions: [
        // 排序种类
        { name: "全部", value: null },
        { name: "单价升序", value: 5 },
        { name: "单价降序", value: 6 },
        { name: "总价升序", value: 7 },
        { name: "总价降序", value: 8 },
      ],
      listParam: {
        // 列表参数
        roomIdOrNo: "", // 房屋门牌号
        belongArea: "", // id
        roomPurpose: "", // 类型
        roomStatus: null, // 状态
        orderEnum: null, // 排序
      },
      companyId: "", // 公司id
      isData: true,
      currentPage: 1,
      currentPageSize: 30,
    };
  },
  created() {
    this.companyId = this.$store.state.initialData.companyId;
    console.log(this.$store.state.initialData.currentPermission)
    this.getData();
    this.getAreaData();
  },
  methods: {
    pull(num) { // 上拉刷新
        console.log('pull回调List');
        this.gainMore()
        // setTimeout(() => {
        //   this.num = num;
        //   if (this.history_list.length >= this.pk_list_data.others_family_list.length) {
        //     console.log('完了');
        //     this.$refs.pull.$emit('loadOver') // 加载完毕
        //   } else {
        //     console.log(666)
        //     this.$refs.pull.$emit('loadEnd') // 加载完毕
        //   }

        // }, 2000)
      },
    inputSearch() {
      // 搜索框输入值搜索
      this.resdata = [];
      this.currentPage = 1;
      this.getData();
    },
    gainMore() {
      // 加载更多数据列表
      this.currentPage += 1;
      this.getData();
    },
    getData() {
      // 获取列表数据
      let that = this;
      let data = {
        ...this.listParam,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        companyId: this.companyId,
      };
      roomList(data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          let responseData = res.data.data.records;
          if (responseData.length == 0) {
            that.$refs.pull.$emit('loadOver') // 加载完毕，无数据了
            that.isData = false;
          } else {
            that.$refs.pull.$emit('loadEnd') // 加载完毕，可能还有下一波数据
            for (let i = 0; i < responseData.length; i++) {
              that.resdata.push(responseData[i]);
            }
            that.isData = true;
          }
        }
      });
    },
    getAreaData() {
      // 获取区域数据
      let that = this;
      let data = {
        companyId: this.companyId,
      };
      areaList(data).then((res) => {
        console.log(res);
        that.areaActions = res.data.data;
      });
    },
    areaSelect(value) {
      // 更改区域
      console.log(value);
      this.listParam.belongArea = value.id;
      this.areaShow = false;
      this.resdata = [];
      this.getData();
    },
    typeSelect(value) {
      // 更改类型
      console.log(value);
      this.listParam.roomPurpose = value.name;
      if (value.name == "全部") {
        this.listParam.roomPurpose = "";
      }
      this.typeShow = false;
      this.resdata = [];
      this.getData();
    },
    statusSelect(value) {
      // 更改状态
      console.log(value);
      this.listParam.roomStatus = value.value;
      this.statusShow = false;
      this.resdata = [];
      this.getData();
    },
    rankSelect(value) {
      // 更改顺序
      console.log(value);
      this.listParam.orderEnum = value.value;
      this.rankShow = false;
      this.resdata = [];
      this.getData();
    },
    navigatePage(item) {
      this.$router.push({
        name: "RoomDetail",
        params: {
          obj: item,
        },
      });
    },
    backPage() {
      // 回退到首页
      this.$router.push("/property-index");
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
  margin-bottom: 0.3rem;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 搜索功能部分 */
.search-content {
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.4rem;
  border-bottom: 1px solid #f0f2f5;
}
.search-content .searchBtn {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #323233;
  margin-left: 0.3rem;
}
.search-content /deep/.ant-input {
  background-color: #f7f8fa;
}
/* 状态筛选部分 */
.status-select {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  height: 1.3rem;
}
.status-select > div {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
}
.status-select /deep/.anticon {
  margin-top: 0.05rem;
}
/* 列表内容部分 */
.list-content {
  margin-top: 0.5rem;
  background-color: white;
  padding: 0.5rem 0;
}
.list-content .content-part {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid #f3f3f3;
}
.content-part img {
  width: 1.5rem;
  height: 1.5rem;
}
.content-part > div {
  display: flex;
  flex-direction: column;
  margin-left: 0.3rem;
  width: 100%;
}
.content-part > div > span:nth-child(1) {
  margin-right: auto;
  font-size: 0.35rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #666;
}
.content-part > div div {
  display: flex;
  align-items: center;
}
.content-part > div div span {
  font-size: 0.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
}
.content-part > div > div:nth-child(1) span:nth-child(2) {
  width: 1.5rem;
  height: 0.55rem;
  background: #f3f3f3;
  border-radius: 2px;
  font-size: 0.2rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #808080;
  text-align: center;
  padding: 0.03rem 0;
  margin-left: auto;
}
.content-part > div > div:nth-child(3) span:nth-child(1) {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #fe5208;
  margin-right: 0.1rem;
}
.content-part > div > div:nth-child(3) span:nth-child(2) {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 1px;
}
.no-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.3rem;
}
.no-data img {
  width: 5rem;
  height: 5rem;
  margin-bottom: 0.5rem;
}
.no-data span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  font-size: 28rpx !important;
}
/* 选择器样式 */
.main-content /deep/.van-picker__toolbar {
  border-bottom: 1px solid #eeeeee;
}
/* 加载更多按钮样式 */
/* .loadMore {
  width: 50%;
  border-radius: 10px;
  margin: 0 auto;
  background-color: #1584ff;
  color: white;
  text-align: center;
  padding: 0.2rem 0;
  margin-top: 0.5rem;
} */
.noMore {
  width: 50%;
  margin: 0 auto;
  color: #ccc;
  text-align: center;
  padding: 0.03rem 0;
  margin-top: 0.5rem;
}
</style>
